"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  writeAnnouncement: 'Write an announcement',
  creatingComplaint: 'Create new appeal/complaint',
  book: 'Book'
};